<template>
  <div>
    <div class="content">
      <base-block class="mb-0">
        <div class="text-center mt-0">
          <h3 class="mt-2">{{ practice.name ? practice.name : "" }}</h3>
          <p class="mt-2">
            {{ practice.description ? practice.description : "" }}
          </p>
        </div>
      </base-block>
      <br />
      <base-block rounded title="Test Details">
        <div class="bg-white rounded p-3 pr-3 pl-3 mb-3">
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Question Selection Type</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{
                practice.test_type == "random"
                  ? "Random"
                  : practice.test_type == "default"
                  ? "Default"
                  : "-"
              }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Duration</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{ practice.duration ? practice.duration : "-" }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Total Question Count</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{
                practice.no_of_questions ? practice.no_of_questions : "-"
              }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Attempts</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{ practice.attempts ? practice.attempts : "-" }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Negative Marks</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{ practice.negative_mark ? practice.negative_mark : "-" }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Each Question Mark</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{
                practice.each_question_mark ? practice.each_question_mark : "-"
              }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Coding</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{ practice.has_coding == 1 ? "Yes" : "No" }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Play & Pause</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{ practice.play_button == 1 ? "Yes" : "No" }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Result Status</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{
                practice.result_status == 1
                  ? "Result"
                  : practice.result_status == 2
                  ? "Result & Solution"
                  : practice.result_status == 3
                  ? "No Result"
                  : "-"
              }}</b>
            </p>
          </div>
        </div>
        <div class="text-center">
          <router-link
            :to="{
              name: 'View Test Questions Practice Test',
              params: {
                subId: this.$route.params.subId,
                testId: this.$route.params.testId,
              },
            }"
          >
            <b-button variant="success"> Next </b-button>
          </router-link>
        </div>
        <br />
      </base-block>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      practice: {},
    };
  },
  mounted() {
    this.getPracticeTest();
  },
  methods: {
    async getPracticeTest() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/sub_practicequestionlist/${this.$route.params.subId}/${this.$route.params.testId}`,
          {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.practice = response.data.test;
            console.log(this.practice);
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>
